import { create } from "zustand";

import { devtools, persist } from "zustand/middleware";

const userStore = (set) => ({
  isUserLogedIn: false,
  appPool: "",
  userRole: "superAdmin",
  userToken: "",
  customerName: "",
  customerObj: {},
  searchObj: [],
  orgObj: [],
  orgActionObj: {},
  xdrObj: {},
  customerFlag: false,
  XdrArr: [],
  sharedObject: {
    speciality: [],
    orgActionObj: {},
    vendorsObj: [],
    xdrSettiingObj: {},
    custumerRecord: {},
    CSRUploadFlag: false,
    usersAdmin: false,
    specialties: [],
    UserIdEmail: {},
    loginObj: {},
    emailsSharing: [],
    reloadEmailList: false,
    reloadUserList: false,
    SystemError: false,
    PreRegisterUser: true,
    UploadObj: [],
    ResetPasswordObj: {},
    ResponseCode: "",
  },
  userSession: {},
  setUserSession: (obj) => {
    set((state) => ({
      userSession: (state.userSession = obj),
    }));
  },
  SetSharedObject: (obj, vl) => {
    set((state) => ({
      sharedObject: (state.orgActionObj = { ...state.orgActionObj, [obj]: vl }),
    }));
  },
  setOrgActionObj: (vl) => {
    set((state) => ({
      orgActionObj: (state.orgActionObj = vl),
    }));
  },
  setRefreshXdrPage: (vl) => {
    set((state) => ({
      customerObj: (state.customerObj = vl),
    }));
  },
  setSearchObj: (vl) => {
    set((state) => ({
      searchObj: (state.searchObj = vl),
    }));
  },
  setOrgObj: (val) => {
    set((state) => ({
      orgObj: (state.orgObj = val),
    }));
  },
  setCustomerObj: (vl) => {
    set((state) => ({
      customerObj: (state.customerObj = vl),
    }));
  },
  setXDRObj: (vl) => {
    set((state) => ({
      xdrObj: (state.xdrObj = vl),
    }));
  },
  setXDRArr: (vl) => {
    set((state) => ({
      XdrArr: (state.XdrArr = vl),
    }));
  },
  setCustomerToken: (vl) => {
    set((state) => ({
      customerName: (state.customerName = vl),
    }));
  },
  setUserToken: (token) => {
    set((state) => ({
      userToken: (state.userToken = token),
    }));
  },
  setUserRole: (role) => {
    set((state) => ({
      userRole: (state.userRole = role),
    }));
  },
  setAppPool: (site) => {
    set((state) => ({
      appPool: (state.appPool = site),
    }));
  },
  setUserLogedIn: (flag) => {
    set((state) => ({
      isUserLogedIn: (state.isUserLogedIn = flag),
    }));
  },
  setCustomerFlag: (flag) => {
    set((state) => ({
      customerFlag: (state.customerFlag = flag),
    }));
  },
});

const useUserStore = create(
  devtools(userStore, {
    name: "user",
  })
);

export default useUserStore;
